/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_comments': {
    width: 24,
    height: 23,
    viewBox: '0 0 24 23',
    data: '<path pid="0" d="M21.6 0H2.4C1.1 0 0 1.1 0 2.4v13.2C0 16.9 1.1 18 2.4 18h11.423l3.881 4.27a.398.398 0 00.44.103A.4.4 0 0018.4 22v-4h3.2c1.3 0 2.4-1.1 2.4-2.4V2.4C24 1.1 22.9 0 21.6 0zM6.4 10.4c-.882 0-1.6-.718-1.6-1.6 0-.882.718-1.6 1.6-1.6.882 0 1.6.718 1.6 1.6 0 .882-.718 1.6-1.6 1.6zm5.6 0c-.882 0-1.6-.718-1.6-1.6 0-.882.718-1.6 1.6-1.6.882 0 1.6.718 1.6 1.6 0 .882-.718 1.6-1.6 1.6zm5.6 0c-.882 0-1.6-.718-1.6-1.6 0-.882.718-1.6 1.6-1.6.882 0 1.6.718 1.6 1.6 0 .882-.718 1.6-1.6 1.6z" _fill="#828282"/>'
  }
})
